// import Dashboard from '../../views/pages/dashboard/view.vue';
import TenantsTable from "../../views/pages/accounts/view";
import AdminsTable from "../../views/pages/admin-users/view";
import TenantPhoneNumbers from "../../views/pages/tenant-phone-numbers/view";
import GlobalMusicHoldsTable from "../../views/pages/global-musiconholds/view";
import PhoneModelsTable from "../../views/pages/phone-models/view";
import GlobalFeatureCodesTable from "../../views/pages/global-feature-codes/view";
import GlobalTimeOfDaysTable from "../../views/pages/global-time-of-days/view";
import GlobalMediafilesTable from "../../views/pages/global-mediafiles/view";
import GlobalDevicesTable from "../../views/pages/global-devices/view";
import RoutingProfilesTable from "../../views/pages/routing-profiles/view";
import PartnerPorting from "../../views/pages/partner-porting/view";
import PartnersTable from "../../views/pages/partners/view";
import ProvidersTable from "../../views/pages/providers/view";
import OmniaThemesTable from "../../views/pages/omnia-themes/view";

import layouts from "../../layout";

export default [
  {
    path: "/accounts",
    name: "accounts",
    component: TenantsTable,
    meta: {
      auth: true,
      layouts: layouts.navLeft,
      searchable: true,
      tags: ["accounts"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/admin/users",
    name: "admin-users",
    component: AdminsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["users"],
      roles: [1]
    }
  },
  {
    path: "/admin/phone-numbers",
    name: "tenant-phone-numbers",
    component: TenantPhoneNumbers,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: false,
      tags: ["dids"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/admin/feature-codes",
    name: "global-feature-codes",
    component: GlobalFeatureCodesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: false,
      tags: ["feature-codes"],
      roles: [1]
    }
  },
  {
    path: "/admin/musiconholds",
    name: "global-musiconholds",
    component: GlobalMusicHoldsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: false,
      tags: ["musiconholds"],
      roles: [1]
    }
  },
  {
    path: "/admin/time-of-days",
    name: "global-time-of-days",
    component: GlobalTimeOfDaysTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: false,
      tags: ["time-of-days"],
      roles: [1]
    }
  },
  {
    path: "/admin/mediafiles",
    name: "global-mediafiles",
    component: GlobalMediafilesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: false,
      tags: ["mediafiles"],
      roles: [1]
    }
  },
  {
    path: "/phone-models",
    name: "phone-models",
    component: PhoneModelsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["phone-models"],
      roles: [1]
    }
  },
  {
    path: "/admin/devices",
    name: "admin-devices",
    component: GlobalDevicesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["admin-devices"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/routing-profiles",
    name: "routing-profiles",
    component: RoutingProfilesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["routing-profiles"],
      roles: [1]
    }
  },
  {
    path: "/partners",
    name: "partners",
    component: PartnersTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["partners"],
      roles: [1]
    }
  },
  {
    path: "/partners/porting",
    name: "partner-porting",
    component: PartnerPorting,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["partner-porting"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/omnia-themes",
    name: "omnia-themes",
    component: OmniaThemesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["omnia-themes"],
      roles: [1, 11]
    }
  },
  {
    path: "/providers",
    name: "providers",
    component: ProvidersTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["providers"],
      roles: [1]
    }
  }
];
